import React from "react";
import { Modal, Text } from "@sede-enterprise/shell-ds-react-framework";
import { noBookSelected } from "../Returns";

// Base modal props shared by all modal types
interface BaseModalProps {
  open: boolean;
  title: string;
  onClose: () => void;
  children: React.ReactNode;
  actions: Array<{
    label: string;
    action: () => void;
    props?: Record<string, any>;
  }>;
}

/**
 * Base modal component that provides common styling and structure
 * for all modal dialogs in the Returns feature
 */
export const BaseModal: React.FC<BaseModalProps> = ({
  open,
  title,
  onClose,
  children,
  actions
}) => {
  return (
    <Modal
      open={open}
      title={title}
      onClose={onClose}
      actions={actions}
    >
      {children}
    </Modal>
  );
};

/**
 * Modal component for confirming a capacity return
 */
export const ConfirmationModal: React.FC<{
  open: boolean;
  onCancel: () => void;
  onConfirm: () => void;
  targetAuction?: string;
  sourceAuction?: string;
  totalCapacity?: number;
  book?: { bookCode: string; bookName: string };
  deliveryPeriod?: string;
}> = ({ open, onCancel, onConfirm, targetAuction, sourceAuction, totalCapacity, book, deliveryPeriod }) => {
  const [confirmingLocal, setConfirmingLocal] = React.useState(false);

  React.useEffect(() => {
    if (!open) {
      setConfirmingLocal(false);
    }
  }, [open]);
  return (
    <BaseModal
      open={open}
      title="Capacity Return"
      onClose={onCancel}
      actions={[
        {
          label: "Cancel",
          action: () => {
            setConfirmingLocal(false);
            onCancel();
          },
          props: { sentiment: "negative" },
        },
        {
          label: "Continue",
          action: () => {
            if (!confirmingLocal) {
              setConfirmingLocal(true);
              onConfirm();
            }
          },
          props: { disabled: confirmingLocal }
        }
      ]}
    >
      <Text size="medium">
        Do you wish to confirm this capacity return? The selected capacity
        will move to the target auction when the return window closes.
      </Text>

      <Text size="medium">
        Your account will only be credited if the capacity is sold during
        auction clearing.
      </Text>

      <div style={{ marginTop: "20px" }}>
        {targetAuction && <Text>Target Auction - {targetAuction}</Text>}

        {sourceAuction && (
          <>
            <Text>Source Auction - {sourceAuction}</Text>
            {totalCapacity !== undefined && (
              <Text>Total Return Capacity - {totalCapacity} MW</Text>
            )}
            {book !== undefined && book.bookCode !== noBookSelected && (
              <Text>Book - {book.bookName}</Text>
              )}
            {deliveryPeriod && <Text>Delivery Period - {deliveryPeriod}</Text>}
          </>
        )}
      </div>
    </BaseModal>
  );
};
